import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import Button from 'components/Button/index'

export const SectionWrapper = styled(Flex)`
  width: 100%;
  border: 1px solid ${COLORS.PAGE_BORDER};
  box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
  border-radius: 10px;
  overflow: scroll;
  height: calc(100vh - 142px);
  overflow-x: hidden;
  background: ${COLORS.WHITE};
  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #cccccc;
  }
`

export const ReportWrapperMain = styled(Flex)`
  width: 100%;
  overflow: scroll;
  border: 1px solid ${COLORS.PAGE_BORDER};
  box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
  border-radius: 10px;
  background: ${COLORS.WHITE};
  &::-webkit-scrollbar {
    display: '';
  }
`

export const TopHeader = styled(Flex)`
  padding: 20px 25px;
  position: relative;
  width: 100%;
  font-size: 2em;
`

export const TopHeading = styled(Flex)`
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: ${COLORS.GREY_P_100};
`

export const TopRightFlex = styled(Flex)`
  gap: 15px;
`

export const SmallButtons = styled(Button.Default)`
  background: ${COLORS.WHITE};
  padding: 9px;
  > div {
    margin-left: 0;
  }
`

export const CardRow = styled(Flex)`
  padding: 0 25px 25px 25px;
  row-gap: 10px;
  column-gap: 15px;
  flex-wrap: wrap;
`

export const PaddedDiv = styled.div`
  padding: 15px;
`

export const SelectAllFlex = styled.div`
  display: flex;
  align-items: center;
  border-radius: 4px;
`

export const ActionBarWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 20px 20px 0px;
`

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`

export const ModalContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 650px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const ShortListModalImg = styled.div`
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  img {
    width: 200px;
    height: 200px;
    object-fit: contain;
  }
`

export const ModalText = styled.div`
  font-size: 16px;
  text-align: center;
  margin-bottom: 20px;
  color: #333;
  font-weight: 600;
`

export const ButtonDiv = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-top: 20px;
`
